module.exports = __webpack_public_path__ + "img/upload_plans.f079cb40.svg";